module.exports = __webpack_public_path__ + "static/media/Buho_DesignBck.a8f4a3a8.svg";